import React from 'react';

export default class ErrorBoundary1 extends React.Component {
    state = {
        error: null,
    };
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        const { error } = this.state;
        const { fallback, children } = this.props;
        if (error) {
            return fallback(error);
        }
        return children;
    }
}